module.exports = __webpack_public_path__ + "img/back.67644c4a.png";